import React from 'react';

import Section from './Section';

const RenaperSelfieTips = ({ onFinish }) => {
  return (<div style={{
      position: "relative",
      display: "block",
      width: "100%",
      height: "100%",
      overflowY: "scroll",
      background: "#ffffff",
    }}>
    <Section className="intro_form">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 text-center">
              <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
          </div>
          <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">
            <h3><b>Necesitamos que hagas algunos gestos.</b></h3>
          </div>
          <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">
            <h4><b>Sirve para confirmar que sos la persona que indica tu DNI.</b></h4>
          </div>
          <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                  <button 
                    type="submit"
                    className="btn btn-warning btn-lg pd-button pd-form"
                    onClick={(event) => {
                      event.preventDefault();
                      onFinish();
                    }}>
                      Entendido
                  </button>
              </div>
          </div>
        </div>
    </Section>
    </div>)
}

module.exports = RenaperSelfieTips;



/** WEBPACK FOOTER **
 ** ./src/components/RenaperSelfieTips.js
 **/